import React from 'react';
import MarkdownPage from '../components/MarkdownPage';
import './Page.css';

const RequestDemo = () => (
  <MarkdownPage contentPath="Call to Action/request-a-demo.md" pageTitle="Request a Demo" />
);

export default RequestDemo;
